module.exports = __webpack_public_path__ + "static/media/image-4.f6f29e55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/WebsiteVsSocialMediaPages/image-4.jpg
// module id = 421
// module chunks = 0